import { render } from "./Tools.vue?vue&type=template&id=ba012c24"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexandrbukhanov/Documents/Документы — MacBook Air — Alexandr/work/dt-teh/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__